import { $Q, $Qll } from "graditify-utils";

/**
 * Price adjustment
 * @param {Number} price - Number (is'nt a decimal reference), expresion like: 1000. The decimals correspond to last 2 digits.
 * @returns {Number} Float number with decimals. Only have 2 digits ofter comma.
 */
const priceFormat = (price) => (price / 100).toFixed(2);

/**
 * Change data when variant is changed
 * @param {HTMLElement} parent
 * @param {Object} variantInfo
 */
const changeData = (parent, { price, comparedPrice, normalPrice, people }) => {
  $Q(".price", parent).innerHTML = `€${priceFormat(price)}`;
  $Q(".compared-price", parent).innerHTML = `€${priceFormat(comparedPrice)}`;
  $Q("#no-suscription-price").innerHTML = `€${priceFormat(normalPrice)}`;
  $Qll(".people").forEach((item) => {
    item.innerHTML = people;
  });
};

/**
 * Set all events for modal
 */
const setModalEvents = () => {
  const modal = $Q(".subscription-modal");

  $Qll(".close-modal").forEach((item) => {
    item.addEventListener("click", (e) => {
      modal.classList.remove("active");
    });
  });

  $Q(".subscription-modal__container").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  $Qll(".open-modal").forEach((item) => {
    item.addEventListener("click", (e) => {
      modal.classList.add("active");
    });
  });
};

/**
 * Set radio inputs events
 */
const setEventsRadioInputs = () => {
  $Qll(".single-option-selector__radio").forEach((item) => {
    item.addEventListener("click", (e) => {
      const input = e.target;
      if (input.checked) {
        const data = JSON.parse(item.getAttribute("data-variant"));
        data.selling_plan_allocations.forEach((plan) => {
          const planCard = $Q(`#plan-${plan.selling_plan_id}`);
          if (planCard) {
            changeData(planCard, {
              price: plan.price,
              comparedPrice: plan.compare_at_price,
              normalPrice: data.price,
              people: item.getAttribute("data-people"),
            });
          }
        });
      }
    });

    if (item.checked) {
      item.dispatchEvent(new Event("click"));
    }
  });
};

export { setEventsRadioInputs, setModalEvents };
